import { useState, useRef, useEffect } from "react";
import "./customSelect.css";

export default function CustomSelect({
    value,
    onChange,
    options = [],
    placeholder = "Select an option",
    className = "",
    multi = false, // 🔥 new prop
}) {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // 🔥 Determine selected options
    let displayLabel = placeholder;

    if (multi) {
        const selectedOptions = options.filter((opt) => Array.isArray(value) && value.includes(opt.value));

        if (selectedOptions.length === 1) {
            displayLabel = selectedOptions[0].label;
        } else if (selectedOptions.length > 1) {
            displayLabel = `${selectedOptions.length} selected`;
        }
    } else {
        const selected = options.find((opt) => opt.value === value);
        if (selected) displayLabel = selected.label;
    }

    return (
        <div className={`cd-wrapper ${className}`} ref={wrapperRef}>
            <div className="cd-selected" onClick={() => setOpen(!open)}>
                {displayLabel}
            </div>

            {open && (
                <div className="cd-options">
                    {options.map((opt) => {
                        const isSelected = multi
                            ? Array.isArray(value) && value.includes(opt.value)
                            : value === opt.value;

                        return (
                            <div
                                key={opt.value}
                                className={`cd-option ${isSelected ? "selected" : ""} ${
                                    opt.disabled ? "disabled" : ""
                                }`}
                                onClick={() => {
                                    if (opt.disabled) return;
                                    if (multi) {
                                        const newValue = Array.isArray(value)
                                            ? value.includes(opt.value)
                                                ? value.filter((v) => v !== opt.value)
                                                : [...value, opt.value]
                                            : [opt.value];

                                        onChange(newValue);
                                        setOpen(false)
                                    } else {
                                        onChange(opt.value);
                                        setOpen(false);
                                    }
                                }}
                            >
                                {opt.label}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

// import { useState, useRef, useEffect } from "react";
// import "./customSelect.css";

// export default function CustomSelect({
// 	value,
// 	onChange,
// 	options = [],
// 	placeholder = "Select an option",
// 	className = "",
// }) {
// 	const [open, setOpen] = useState(false);
// 	const wrapperRef = useRef(null);

// 	// Close dropdown when clicking outside
// 	useEffect(() => {
// 		function handleClickOutside(e) {
// 			if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
// 				setOpen(false);
// 			}
// 		}
// 		document.addEventListener("mousedown", handleClickOutside);
// 		return () => document.removeEventListener("mousedown", handleClickOutside);
// 	}, []);

// 	const selected = options.find((opt) => opt.value === value);

// 	return (
// 		<div className={`cd-wrapper ${className}`} ref={wrapperRef}>
// 			<div className="cd-selected" onClick={() => setOpen(!open)}>
// 				{selected ? selected.label : placeholder}
// 			</div>

// 			{open && (
// 				<div className="cd-options">
// 					{options.map((opt) => (
// 						<div
// 							key={opt.value}
// 							className="cd-option"
// 							onClick={() => {
// 								onChange(opt.value);
// 								setOpen(false);
// 							}}
// 						>
// 							{opt.label}
// 						</div>
// 					))}
// 				</div>
// 			)}
// 		</div>
// 	);
// }
